export enum DMEPOS_ACCOUNT_TYPE_ENUM {
    DMEPOS_PROVIDER = 'DMEPOS Provider',
  }
  